export default "__VITE_ASSET__BVWcCOh3__"